var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sm-text',{attrs:{"text":("※印刷はブラウザメニューの[印刷]より「" + _vm.size + "サイズ・" + _vm.direction + "向き」に設定のうえ行ってください"),"format":"sm__caption","color":"black","level":"2"}})}
var staticRenderFns = []

export { render, staticRenderFns }